import router from 'next/router';

const getQueryString = ({
  credsApplied,
  referralCode = '',
  gUid,
  payment_status = 'false'
}) => {
  const { inside_app, app_redirection, source } = router.query;
  const queryParams = new URLSearchParams();
  if (credsApplied) queryParams.append('credsApplied', 'true');
  if (referralCode) queryParams.append('referral_code', referralCode);
  if (gUid) queryParams.append('gUid', gUid);
  if (source === 'app') queryParams.append('source', source);
  if (payment_status === 'failed' || payment_status === 'success')
    queryParams.append('payment_status', payment_status);
  if (inside_app) queryParams.append('inside_app', inside_app);
  if (app_redirection) queryParams.append('app_redirection', app_redirection);
  const extraParams = queryParams.toString()
    ? `?${queryParams.toString()}`
    : '';

  return extraParams;
};

export default getQueryString;
